import { InfoIcon, PhoneCallIcon } from "lucide-react";

import { Row } from "@/components/Row";
import { Text } from "@/components/Text";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import { CallNowBadgeVariant } from "@/types";

const TOOLTIP_COPY: Record<CallNowBadgeVariant, string> = {
  [CallNowBadgeVariant.TOP_PRIORITY]:
    "This is a Top Priority Candidate — call them directly. Cold calling results in a 33% higher rate of completed screens than scheduling over text, and candidates of this caliber are contacted quickly. If you don't reach them first, another agency will.",
  [CallNowBadgeVariant.SMART_SOURCED]:
    "You smart sourced this candidate and you should call them immediately. Leave a voicemail if you have to. There's nothing better from a job prospect's perspective than hearing directly from a recruiter.",
};

// Red call-to-action pill for candidates the staffer should be calling —
// pushes them to call instead of texting toward a screen.
export const TopPriorityCandidateBadge = ({
  variant,
}: {
  variant: CallNowBadgeVariant;
}) => {
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Row className="h-9 items-center gap-1.5 rounded-full border border-red-200 bg-red-50 px-3.5">
            <PhoneCallIcon className="h-3.5 w-3.5 shrink-0 text-red-600" />
            <Text className="text-xs font-semibold text-red-700">
              Call this candidate!
            </Text>
            <InfoIcon className="h-3.5 w-3.5 shrink-0 text-red-400" />
          </Row>
        </TooltipTrigger>
        <TooltipContent className="max-w-80" side="bottom">
          <Text className="text-sm font-normal leading-snug text-slate-700">
            {TOOLTIP_COPY[variant]}
          </Text>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
